// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__126SD","title":"Images90_title__1W_LW","images":"Images90_images__2WhLM"};